export default __webpack_public_path__ + "static/media/choppy.ada274e9.svg";